class FilterableVariants extends HTMLElement {
  constructor() {
    super();

    this.filter = this.querySelector("fv-filter");
    this.variants = this.querySelectorAll(".fv-variant");
    this.grids = this.querySelectorAll("fv-grid");

    this.addEventListener("filterOptionsChanged", ({ detail }) => {
      this.onOptionsChanged(detail.options);
      this.scrollIntoView({ behavior: "smooth" });
    });
  }

  onOptionsChanged(options) {
    const empty = Object.values(options).every((o) => o.length === 0);

    this.variants.forEach((v) =>
      v.classList.toggle(
        "hidden",
        !(
          empty ||
          Object.keys(options).every(
            (key) =>
              options[key].length === 0 ||
              !v.dataset[key] ||
              options[key].includes(v.dataset[key])
          )
        )
      )
    );

    this.grids.forEach((grid) => grid.onOptionsChanged(options));

    // Array.from(this.variants)
    //   .filter((v) => !v.classList.contains("hidden"))
    //   .forEach((v, i) => {
    //     if (i < 9) v.classList.remove("fv-variant--next-page");
    //   });
  }
}

class FilterableVariantsGrid extends HTMLElement {
  constructor() {
    super();
  }

  onOptionsChanged(options) {
    if (options.option2.length > 1)
      [...this.children]
        .sort(
          (a, b) =>
            options.option2.findIndex((o) => o === a.dataset.option2) -
            options.option2.findIndex((o) => o === b.dataset.option2)
        )
        .forEach((node) => this.appendChild(node));
  }

  // this.addEventListener("filterOptionsChanged", ({ detail: { options } }) => {
  //   if (options.option1.length > 1)
  //     [...this.children]
  //       .sort(
  //         (a, b) =>
  //           options.option1.findIndex((o) => o === a.dataset.option1) -
  //           options.option1.findIndex((o) => o === b.dataset.option1)
  //       )
  //       .forEach((node) => this.appendChild(node));
  // });

  // this.expandButton = this.nextElementSibling;
  // this.variants = this.querySelectorAll(".fv-variant");

  // this.expandButton.addEventListener("click", () => {
  //   this.classList.add("filterable-variants__grid--expanded");
  //   this.expandButton.classList.add("hidden");
  // });

  // this.addEventListener("filterOptionsChanged", () => {
  //   this.expandButton.classList.toggle(
  //     "hidden",
  //     this.querySelectorAll(".fv-variant").length > 9
  //   );
  // });

  // this.expandButton.addEventListener("click", () => {
  //   this.variants.forEach((v) => v.classList.remove("hidden"));
  //   this.expandButton.classList.add("hidden");
  // });
}

class FilterableVariantsFilter extends HTMLElement {
  constructor() {
    super();

    this.options = this.querySelectorAll("input[type=checkbox]");
    this.clearButton = this.querySelector(".fv-filter__clear");

    this.viewAllButtons = document.querySelectorAll(
      ".filterable-variants__expand"
    );

    this.selectedOptions = {
      option1: [],
      option2: ["Moss Green"],
      option3: ["Low", "High"],
    };

    this.clearButton.addEventListener("click", this.clear.bind(this));

    this.viewAllButtons.forEach((b) =>
      b.addEventListener("click", this.clear.bind(this))
    );

    this.options.forEach((option) =>
      option.addEventListener("change", this.toggleOption.bind(this))
    );
  }

  toggleOption(e) {
    const { name: option, value, checked } = e.target;

    if (checked) this.onSelectOption(option, value);
    else this.onDeselectOption(option, value);

    this.onOptionsChange();
  }

  onSelectOption(option, value) {
    this.selectedOptions[option].unshift(value);
  }

  onDeselectOption(option, value) {
    this.selectedOptions[option] = this.selectedOptions[option].filter(
      (o) => o !== value
    );
  }

  onOptionsChange() {
    const shouldDisableButtons = Object.values(this.selectedOptions).every(
      (o) => o.length === 0
    );

    this.clearButton.disabled = shouldDisableButtons;
    this.viewAllButtons.forEach((b) => (b.disabled = shouldDisableButtons));

    this.dispatchEvent(
      new CustomEvent("filterOptionsChanged", {
        detail: { options: this.selectedOptions },
        bubbles: true,
      })
    );
  }

  clear() {
    this.options.forEach((option) => (option.checked = false));
    this.selectedOptions = { option1: [], option2: [], option3: [] };
    this.onOptionsChange();
  }
}

if (!customElements.get("fv-grid"))
  customElements.define("fv-grid", FilterableVariantsGrid);

if (!customElements.get("filterable-variants"))
  customElements.define("filterable-variants", FilterableVariants);

if (!customElements.get("fv-filter"))
  customElements.define("fv-filter", FilterableVariantsFilter);
